import { render, staticRenderFns } from "./newsEnt1.vue?vue&type=template&id=0aaf3e48&scoped=true&"
import script from "./newsEnt1.vue?vue&type=script&lang=js&"
export * from "./newsEnt1.vue?vue&type=script&lang=js&"
import style0 from "./newsEnt1.vue?vue&type=style&index=0&lang=css&"
import style1 from "./newsEnt1.vue?vue&type=style&index=1&id=0aaf3e48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aaf3e48",
  null
  
)

export default component.exports